// extracted by mini-css-extract-plugin
export default {"title":"PasswordChanged_title__pnbo6","description":"PasswordChanged_description__g+rPP","button":"PasswordChanged_button__NDeRb"};